import { Component, EventEmitter, Output } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { ClienteService } from 'src/app/services/cliente.service';

@Component({
  selector: 'app-cliente-exclusao',
  templateUrl: './cliente-exclusao.component.html',
  styleUrls: ['./cliente-exclusao.component.scss']
})
export class ClienteExclusaoComponent {
  visivel: boolean = false;
  registro: any = {};
  validacoes: string[] = [];

  @Output()
  onSucesso: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private app: AppComponent,
    private clienteService: ClienteService) {
  }

  abrir(registro: any) {
    this.visivel = true;
    this.registro = registro;
  }

  fechar() {
    this.visivel = false;
    this.registro = {};
    this.validacoes = [];
  }

  confirmar() {
    this.app.bloquearTela();
    this.validacoes = [];

    this.clienteService
      .excluir(this.registro.id)
      .subscribe(response => {
        this.app.desbloquearTela();

        if (response.sucesso) {
          this.onSucesso.emit(this.registro);
          this.fechar();
        } else {
          this.validacoes = response.mensagens!;
        }
      });
  }
}